export const isDatasetDefinitionReloadRequired = (
  formId: string | undefined,
  hasSubmitted: boolean
): boolean => hasSubmitted && formId === 'viewColumns';
